<template>
  <v-dialog :value="isActive" @click:outside="$emit('update:isActive', false)" width="600px">
    <v-card>
      <v-card-title class="primary white--text d-flex justify-space-between">
        <span>Add User</span>
        <v-btn text icon dark @click="$emit('update:isActive', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <custom-form :fields="user" method="post" :action="url" @submitted="$emit('added', $event)">
          <v-row no-gutters>
            <v-col cols="6" class="px-1">
              <custom-input name="first_name" label="First name" />
            </v-col>
            <v-col cols="6" class="px-1">
              <custom-input name="last_name" label="last name" />
            </v-col>
            <v-col cols="12" class="px-1">
              <custom-input name="email" label="Email Address" />
            </v-col>
            <v-col cols="3" class="px-1">
              <custom-input name="country_code" label="Country Code" />
            </v-col>
            <v-col cols="9" class="px-1">
              <custom-input name="phone_number" label="Phone Number" />
            </v-col>
            <v-col cols="12" class="px-1">
              <custom-button block color="primary">
                <v-icon>mdi-account-plus</v-icon>Add
              </custom-button>
            </v-col>
          </v-row>
        </custom-form>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    isActive: { required: true, type: Boolean },
    user: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      url: "/api/v1/users",
    };
  },
};
</script>
